// 顶部引入库保持不变
import html2canvas from 'html2canvas';
import globalStateManager from './state-manager';
import { setTimeout } from 'core-js';
import { API_BASE_URL } from '../../config';
// 获取特定 class 的元素值
function getSpriteInputValue() {
  try {
    // 直接通过 class 名获取元素
    const inputElement = document.querySelector('.sprite-info_sprite-input_17wjb');

    if (inputElement) {
      // 根据元素类型获取值
      if (inputElement.tagName === 'INPUT' || inputElement.tagName === 'TEXTAREA') {
        return inputElement.value;
      } else if (inputElement.hasAttribute('value')) {
        return inputElement.getAttribute('value');
      } else {
        return inputElement.textContent || inputElement.innerText;
      }
    }

    console.warn('未找到 class="sprite-info_sprite-input_17wjb" 的元素');
    return null;
  } catch (error) {
    console.error('获取元素值时出错:', error);
    return null;
  }
}
console.log('-----------updatetoweb-blob.js',API_BASE_URL)



// 在文件顶部添加下载函数
// function downloadBlob(blob, filename) {
//   try {
//     const url = URL.createObjectURL(blob);
//     const downloadLink = document.createElement('a');
//     downloadLink.href = url;
//     downloadLink.download = filename;
//     downloadLink.style.display = 'none';
//     document.body.appendChild(downloadLink);
//     downloadLink.click();
//     setTimeout(() => {
//       URL.revokeObjectURL(url);
//       document.body.removeChild(downloadLink);
//     }, 100);
//     return true;
//   } catch (error) {
//     console.error('下载失败:', error);
//     return false;
//   }
// }

export default (filename, blob) => {
  // 更新状态为"提交中"
  globalStateManager.updateState({
    isSubmitting: true,
    showSuccess: false
  });

  const downloadLink = document.createElement('a');
  document.body.appendChild(downloadLink);
  //设置BLOG转化为文件
  var file = new File([blob], filename, { type: blob.type, lastModifed: Date.now() });
  console.log(file)
  // Use special ms version if available to get it working on Edge.
  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, filename);
    return;
  }
  let updateurl = '';
  let sendStr = '';
  let ContentType = '';
  var form = new FormData();
  let contType = true;

  // 可以增加表单数据
  form.append("jwt", window.sessionStorage.getItem('jwt'));
  form.append("content", window.sessionStorage.getItem('content'));
  form.append("_id", window.sessionStorage.getItem('_id'));
  form.append('file', file);
  // form.append("file", file);
  if (window.sessionStorage.getItem('mode') == 0) {
    //  存入做题表
    //updateurl ='https://bth.educg.net/scratchapi/saveSelfProject.do'
   updateurl = `${API_BASE_URL}scratchapi/saveSelfProject.do`
  //  updateurl = `https://bd.t.educg.com/scratchapi/saveSelfProject.do`;
    if (JSON.parse(window.sessionStorage.getItem('tabZX'))) {
      // 传file
      sendStr = form;
      contType = false;
    }
    else {
      sendStr = `jwt=${window.sessionStorage.getItem('jwt')}&content=${encodeURI(window.sessionStorage.getItem('content'))}&_id=${window.sessionStorage.getItem('_id')}`
      ContentType = `application/x-www-form-urlencoded`;
      contType = true;
    }
    // var autoMessage = { score: 0 }//this.state;
    // window.parent.postMessage(autoMessage, '*')
    html2canvas(document.body).then(canvas => {
      const spriteInputValue = getSpriteInputValue();
      canvas.toBlob(screenshotBlob => {
        // 创建合并后的消息对象
        const mergedMessage = {
          score: 0, // 保留原始autoMessage数据
          // screen: screenshotBlob,
          // role: spriteInputValue,
          sb3Json:window.sessionStorage.getItem('content')
        };
        console.log('screenshotBlob', mergedMessage)
        // 发送合并后的消息
        window.parent.postMessage(mergedMessage, '*');
      }, 'image/png');
      console.log('mergedMessage', -0)

    });
    window.parent.postMessage(
      {
        type: "scratch_submit",
        data: {
          // url: `chat/${result.data.agent_id}`,
          timestamp: new Date().getTime(),
          // jwt:window.sessionStorage.getItem('jwt')
        },
      },
      "*"
    );
    // console.log('mergedMessage', -1)
    
    
  }
  else if (window.sessionStorage.getItem('mode') == 1 || window.sessionStorage.getItem('mode') == 2) {
   
    html2canvas(document.body).then(canvas => {
      const spriteInputValue = getSpriteInputValue();
      canvas.toBlob(screenshotBlob => {
        // 创建合并后的消息对象
        const mergedMessage = {
          score: -100, // 保留原始autoMessage数据
          // screen: screenshotBlob,
          // role: spriteInputValue,
          sb3Json:window.sessionStorage.getItem('content')

        };
        console.log('screenshotBlob', mergedMessage)

        // 发送合并后的消息
        window.parent.postMessage(mergedMessage, '*');
      }, 'image/png');
      console.log('mergedMessage', -300)

    });
    // 出题表的接口
    //updateurl = 'https://bth.educg.net/scratchapi/saveProject.do';
    //https://fs.t.educg.com/   恢复 https://fs.api.eduxiji.net
    updateurl = `${API_BASE_URL}scratchapi/saveProject.do`;// "https://fs.api.eduxiji.net/scratchapi/saveProject.do"// 接口
    sendStr = form;
    contType = false;
    // ContentType=`multipart/form-data`

  }

  // uplodurl定义
  var uplodurl;

  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {

    if (this.readyState == 4) {
      if (this.status == 200) {
        console.log(JSON.parse(this.responseText))
        const getData = JSON.parse(this.responseText)
        if (getData.value == 'ok') {
     
       
          // 请求成功，显示成功提示
          globalStateManager.updateState({
            isSubmitting: false,
            showSuccess: true
          });

          window.onbeforeunload = null
          //  document.getElementById("demo").innerHTML = this.responseText;
          window.sessionStorage.setItem('_id', getData._id)
        } else {
          // 请求失败，重置状态
          globalStateManager.updateState({
            isSubmitting: false,
            showSuccess: false
          });
          alert(getData.message)
        }

        // alert(getData.message)
        //  增加_id 编辑

        // _id=getData._id        
      }
      else {
        // 请求失败，重置状态
        globalStateManager.updateState({
          isSubmitting: false,
          showSuccess: false
        });


      }
    }
  };
  xhttp.open("POST", updateurl, true);
  if (contType) {
    xhttp.setRequestHeader("Content-type", ContentType);
  }

  // xhttp.send(JSON.stringify(tempdata));
  xhttp.send(sendStr);

  // const url = window.URL.createObjectURL(blob);
  // downloadLink.href = url;
  // downloadLink.download = filename;
  // downloadLink.type = blob.type;
  // downloadLink.click();
  // document.body.removeChild(downloadLink);
  // window.URL.revokeObjectURL(url);
  // if ('download' in HTMLAnchorElement.prototype) {
  //     debugger
  //     const url = window.URL.createObjectURL(blob);
  //     downloadLink.href = url;
  //     downloadLink.download = filename;
  //     downloadLink.type = blob.type;
  //     downloadLink.click();
  //     // remove the link after a timeout to prevent a crash on iOS 13 Safari
  //     window.setTimeout(() => {
  //         document.body.removeChild(downloadLink);
  //         window.URL.revokeObjectURL(url);
  //     }, 1000);
  // } else {
  //     // iOS 12 Safari, open a new page and set href to data-uri
  //     let popup = window.open('', '_blank');
  //     const reader = new FileReader();
  //     reader.onloadend = function () {
  //         popup.location.href = reader.result;
  //         popup = null;
  //     };
  //     reader.readAsDataURL(blob);
  // }

};
